import { Badge } from '@/components/ui/badge';
import { useT, type I18nKey } from '@/lib/i18n';
import { Status } from '@/data/types';

const variantMap: Record<Status, 'success' | 'warning' | 'info' | 'secondary'> =
  {
    [Status.DONE]: 'success',
    [Status.WAITING]: 'warning',
    [Status.TODO]: 'info',
    [Status.NONE]: 'secondary',
  };

const labelKeyMap: Record<Status, I18nKey> = {
  [Status.DONE]: 'status.done',
  [Status.WAITING]: 'status.waiting',
  [Status.TODO]: 'status.todo',
  [Status.NONE]: 'status.none',
};

export function StatusBadge({ status }: { status: Status }) {
  const t = useT();
  return <Badge variant={variantMap[status]}>{t(labelKeyMap[status])}</Badge>;
}

export function StatusDot({ status }: { status: Status }) {
  const color =
    status === Status.DONE
      ? 'bg-emerald-500'
      : status === Status.WAITING
        ? 'bg-amber-500'
        : status === Status.TODO
          ? 'bg-blue-500'
          : 'bg-slate-400';
  return <span className={`inline-block h-2.5 w-2.5 rounded-full ${color}`} />;
}
